export const GET_COUPONS_SUCCESS = 'GET_COUPONS_SUCCESS';
export const GET_COUPONS_REQUESTED = 'GET_COUPONS_REQUESTED';
export const DELETE_COUPON_REQUESTED = 'DELETE_COUPON_REQUESTED';
export const ADD_COUPON_REQUESTED = 'ADD_COUPON_REQUESTED';
export const UPDATE_COUPON_REQUESTED = 'UPDATE_COUPON_REQUESTED';
